import { COLOR_ERROR } from '@elfsight/widget-form-builder/widget';
import { widgetButtonDefaults } from '@elfsight/widget-ui';
import { colors } from '../../constants';
import type { FormAppearance } from '../../types';

const { black, black02, black05, brightBlue } = colors;

export const defaultFormAppearance: FormAppearance = {
  fieldActiveColor: brightBlue,
  fieldLabelPosition: 'outside',
  fieldHeadingColor: black,
  fieldInsideLabelColor: black05,
  fieldLabelColor: black,
  fieldColor: black,
  fieldHintColor: black05,
  fieldFillColor: 'transparent',
  fieldBorderType: 'outline',
  fieldBorderWidth: 1,
  fieldBorderRadius: 4,
  fieldBorderColor: black02,
  fieldHeadingFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  },
  fieldInsideLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    textTransform: undefined
  },
  fieldLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  },
  fieldFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  fieldHintFontStyle: {
    fontSize: 13
  },
  fieldSpacing: 20,
  submitMessageAlignment: 'center',
  submitMessageTitleColor: black,
  submitMessageTextColor: black05,
  submitMessageButtonColor: brightBlue,
  submitMessageTitleFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  },
  submitMessageTextFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  },
  submitButtonProps: {
    ...widgetButtonDefaults,
    fullWidth: true
  },
  submitButtonAlignment: 'center',
  widgetFooterTextColor: black05,
  widgetFooterLinksColor: brightBlue,
  widgetFooterTextStyle: {
    fontSize: 13
  },
  errorColor: COLOR_ERROR
};
